import React from 'react'
import Link from 'gatsby-link'
import Artwork from '../components/artwork'
import styled from 'styled-components'

const Gallery = styled.div`
	display: grid;
	padding: 4rem;
	padding-top: 0;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	grid-gap: 4rem;
	align-items: center;
	@media(max-width: 500px) {
		grid-gap: 2rem;
		padding: 2rem;
		grid-template-columns: 1fr;
	}
`

const IndexPage = ({ data }) => (
  <Gallery>
	{data.allFile.edges.map((x) => <Artwork key={x.node.publicURL} name={x.node.name} srcSet={x.node.childImageSharp.responsiveSizes} alt={x.node.name}/>)}
  </Gallery>
)

export default IndexPage

export const query = graphql`
	query indexQuery {
	  allFile(
	  	filter: {name: {ne: ".DS_Store"}}
	  	sort: {fields: [birthTime], order: DESC} 
	  ) {
	    edges {
	      node {
	        name
	        uid
	        publicURL
	        modifiedTime
	        childImageSharp {
	          responsiveSizes(maxWidth: 1000) {
	            srcSet
                src
                sizes
	          }
	        }
	      }
	    }
	  }
	}
`



// WEBPACK FOOTER //
// ./src/pages/index.js